/**
 * Hook utilitaire — Mode démo Courtier Light
 *
 * Retourne `true` si l'utilisateur connecté est le compte de démonstration
 * version Courtier (demo_mode === "courtier").
 * Utilisé pour masquer progressivement les sections non pertinentes
 * pour un prospect courtier.
 */
import { useAuth } from '../components/Auth/AuthContext';

export const useCourtierLight = () => {
  const { user } = useAuth();
  return user?.demo_mode === 'courtier';
};
